<template>
<div class="sticky">
    <header>


        <div class="header_container" style="z-index:200000;">


            <!--<div class="logo">-->
            <!--<a href="http://www.falkoping.se" target="_blank">
            <img alt="Gå till Falköpings kommuns hemsida" width="143" height="33" src="./static/images/falkoping.png" style="margin-left:10px; margin-right:10px">
        </a>-->
            <!--</div>-->
        </div>
        <app-system-menu style="z-index:-1;"></app-system-menu>
        <div class="app_name">
            <div class="fk-systemicon"><i style="font-size:28px;line-height:45px;margin-right:5px;" class="bi bi-exclamation-triangle"></i></div><div class="fk-systemtext"><span class="thin">Krisindikatorer.se</span></div>
        </div>
        <!--<div class="sirener"><img class="top_image" alt="Sirener" src="static/images/megafon.png"></div>-->


    </header>
    
</div>
</template>
<script>

    import SystemMenu from "./SystemMenu.vue";
    export default {
        components: {
            appSystemMenu: SystemMenu
        }
    };

</script>

<style>

    :root {
        --dur: 20s;
    }

    .header_container {
        display: flex;
        justify-content: right;       
    }

    .app_name {
        color: rgba(0,20,30,0.6) !important;
        display: flex;
        text-shadow: 2px 2px 1px rgba(0,0,0,0.3);
        position: absolute;
        right: 20px;
        margin-top: -50px;
        letter-spacing: 1px;
    }

    .fk-systemicon {
        font-weight: 700;
        margin-bottom: 0.9rem;
        margin-left: 20px;
        margin-right: 5px;
        margin-top: 0.2rem;
        font-size: 2.0rem;
        opacity: 0.7;
        color: white;
    }

    .fk-systemtext {
        font-size: 22px !important;
        margin-top: 10px !important; 
    }

    .phat {
        font-weight: 900;
    }

    .thin {
        font-weight: 400;
        color: white;
        opacity: 0.7;
    }

    .sirener {
        position: absolute;
        top: 0;
        right: 20px;        
    }

    .top_image {
        height: 130px;
        opacity: 1;
    }

</style>




// WEBPACK FOOTER //
// src/Header.vue